module.exports = __webpack_public_path__ + "img/banner-bg.369528c6.jpg";